import { createElement, Props as ReactProps } from "react";
import Order from "../../../../entity/order";
import {
  Descriptions,
} from 'antd';
import * as moment from 'moment';
import Store from "../../../../entity/store";

type Props = ReactProps<HTMLSpanElement> & {
  order: Order;
  store: Store;
};

const DeliveryColumns = [
  { label: 'お名前', key: 'shipName', span: 1 },
  { label: 'ふりがな', key: 'phonetic', span: 1 },
  { label: '電話番号', key: 'phone', span: 1 },
  { label: 'メールアドレス', key: 'email', span: 1 },
  { label: 'お届け日時', key: 'shipDate', span: 1,
    func: (val: string) => {
      return moment(val).format('LLL');
    }
  },
  { label: 'お届け方法', key: 'shipMethod', span: 1,
    func: (_: string) => {
      return '配送';
    }
  },
  { label: '郵便番号', key: 'shipZipCode', span: 1 },
  { label: '都道府県', key: 'region', span: 1 },
  { label: '市区町村', key: 'city', span: 1 },
  { label: '住所', key: 'shipAddress1', span: 3 },
  { label: '建物名、部屋番号等', key: 'shipAddress2', span: 3 },
  { label: '支払い方法', key: 'payment', span: 3,
    func: (payment: string) => {
      if (payment === 'before-credit') {
        return 'クレジット決済';
      }
      return '現地決済';
    }
  },
  { label: '備考', key: 'note', span: 3 },
];

const TakeoutColumns = [
  { label: 'お名前', key: 'shipName', span: 1 },
  { label: 'ふりがな', key: 'phonetic', span: 1 },
  { label: '電話番号', key: 'phone', span: 1 },
  { label: 'メールアドレス', key: 'email', span: 1 },
  { label: 'お届け日時', key: 'shipDate', span: 1,
    func: (val: string) => {
      return moment(val).format('LLL');
    }
  },
  { label: 'お届け方法', key: 'shipMethod', span: 1,
    func: (_: string) => {
      return '店舗受け取り';
    }
  },
  { label: '支払い方法', key: 'payment', span: 3,
    func: (payment: string) => {
      if (payment === 'before-credit') {
        return 'クレジット決済';
      }
      return '現地決済';
    }
  },
  { label: '備考', key: 'note', span: 3 },
];

const OrderSummary = (props: Props) => {
  const {
    order,
    store,
  } = props;

  const columns = order.shipMethod === 'shop' ? TakeoutColumns : DeliveryColumns;

  const descItems = columns.reduce((data: any[], column: any) => {
    if (column.key === 'shipZipCode' &&  store.shipAreaType === 'city') {
      return data;
    }
    data.push(
      <Descriptions.Item label={column.label} span={column.span} key={column.key}>
        {
          column.func ? column.func(order[column.key]) : order[column.key]
        }
      </Descriptions.Item>
    );

    return data;
  }, [] as any[]);

  return (
    <Descriptions title="注文情報" bordered={true}>
      {descItems}
    </Descriptions>
  );
};

export default OrderSummary;
